const documentos = [
  {
    slug: "proceso-comercial-completo",
    titulo: "Proceso Comercial Completo",
    pdf: "proceso-comercial-completo.pdf",
  },
  {
    slug: "generacion-demanda-omnicanal",
    titulo: "Generación Demanda Omnicanal",
    pdf: "01-Generación-de-Demanda-Omnicanal.pdf",
  },
  {
    slug: "analisis-requerimientos",
    titulo: "Análisis de Requerimientos",
    pdf: "03-analisis-de-requerimientos.pdf",
  },
  {
    slug: "asignacion-cuentas-segmentacion-oportunidades",
    titulo: "Asignación de Cuentas y Segmentación de Oportunidades",
    pdf: "02-asignación-de-cuentas-y-segmentación-de-oportunidades.pdf",
  },
  {
    slug: "disenio-solucion-propuesta-tecnico-comercial",
    titulo: "Diseño de Solución y Propuesta Técnico-Comercial",
    pdf: "04-diseño-de-solucion-y-propuesta-tecnico-comercial.pdf",
  },
  {
    slug: "disenio-solucion-propuesta-tecnico-comercial-raci",
    titulo: "Diseño de Solución y Propuesta Técnico-Comercial Matriz RACI",
    pdf: "04-diseño-de-solucion-y-propuesta-tecnico-comercial-RACI.pdf",
  },
  {
    slug: "fase-negociacion-cierre",
    titulo: "Fase de Negociación y Cierre",
    pdf: "06-fase-negociacion-y-cierre.pdf",
  },
];

export default documentos;
